import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Strings from '../../../../Strings';
import { makeValid } from '../../../../utils';
import TableWidget from '../component/TableWidget';
import { datesText } from '../../../../utils/cmsPrograms';
import { PERMISSIONS, hasPermission } from '../../../../utils/userPermissions';
import { ACTIVATION_METHODS } from '../../../../utils/enrollmentFields';

export const renderPrescriber = p => `${p.firstName} ${p.lastName || ''}`;
export const renderPatientMedication = m => `${m.name} ${m.ndc ? `(${m.ndc})` : ''} ${m.sig ? `${Strings.patient_medications.sig}: ${m.sig} ` : ''}${!_.isEmpty(m.prescriber) ? `Perscribed by: ${renderPrescriber(m.prescriber)}` : ''}`;
function MedicalHistory(props) {
  const { conditions, programs, medications, isLoading, enrollmentId } = props;

  const data = React.useMemo(() => {
    const ret = [];
    if (programs) {
      const program = programs.find(p => p.enrollmentId === enrollmentId);
      if (program && program.program) {
        ret.push([Strings.program, program.displayName]);
        if (program.careProvider) {
          ret.push([Strings.capPatient.careProvider, `${program.careProvider.name} (${program.careProviderOrg?.name})`]);
        }
        if (program.careProviderOrg?.name && !program.careProvider) {
          ret.push([Strings.capPatient.careProvider, program.careProviderOrg?.name]);
        }
        if (program.enrollmentStart || program.enrollmentEnd) {
          ret.push([Strings.activationStartEnd, datesText(program)]);
        }
        if (program.activationMethod !== ACTIVATION_METHODS.Manual) {
          ret.push([Strings.capPatient.enrollmentWillActivate, Strings.capPatient.enrollmentActivationModesEnum[program.activationMethod]]);
        }
      }
    }
    if (conditions) {
      Object.values(conditions).forEach((v, i) => {
        ret.push([Strings.condition, makeValid(v.title)]);
      });
    }
    if (medications) {
      medications.forEach(m => {
        ret.push([Strings.medication, renderPatientMedication(m)]);
      });
    }
    return ret;
  }, [enrollmentId, conditions, programs, medications]);

  const canEdit = hasPermission(PERMISSIONS.CARE_MANAGEMENT_PATIENT_INFO_EDIT);

  return (
    <TableWidget
      title={Strings.capPatient.medicalHistory}
      buttons={props.onEdit && canEdit ? [{ icon: 'edit', onClick: props.onEdit, id: 'edit-medical-history-button' }] : undefined}
      data={data}
      isLoading={isLoading}
      firstColumnClassName="medical-history-col"
    />
  );
}

MedicalHistory.propTypes = {
  isLoading: PropTypes.any,
  conditions: PropTypes.any,
  enrollment: PropTypes.any,
  patientId: PropTypes.any,
  onEdit: PropTypes.func,
};
MedicalHistory.widgetId = 'MedicalHistoryWidget';

export default MedicalHistory;
